<template>
  <div class="row recursive-row" v-show="show" >
    <div class="col-sm-9 col-md-4 ellipsis-text align-self-center">
      <indented-span :level="level + 1" :hasHighlight="searchMatchesName">
        {{ user.full_name }}
      </indented-span> <active-tag class="d-md-none" :isActive="user.is_active" :isConfirmed="user.is_confirmed" />
    </div>
    <div class="col-md-2 d-none d-md-block align-self-center">
      <role-tag :role="user.role" />
    </div>
    <div :class="{ 'text-success': searchMatchesEmail, 'font-weight-bold': searchMatchesEmail }" class="col-md-3 d-none d-md-block ellipsis-text align-self-center">
      {{ user.email }}
    </div>
    <div v-if="showResendEmail" class="col-md-1 d-none d-md-block align-self-center">
      <a class="badge badge-info resend-email" @click="resendConfirmUserEmail(user)">Resend Email</a>
    </div>
    <active-column v-else :isActive="user.is_active" :isConfirmed="user.is_confirmed" />
    <div class="col-sm-2 text-right align-self-center">
      <button class="btn btn-sm" @click="selectUser">Select</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import IndentedSpan from '../IndentedSpan.vue';
import ActiveTag from '../Tags/ActiveTag.vue';
import ActiveColumn from './ActiveColumn.vue';
import RoleTag from '../Tags/RoleTag.vue';
import config from '../../constants/config';

export default {
  components: {
    IndentedSpan,
    ActiveTag,
    ActiveColumn,
    RoleTag
  },
  name: 'UserRow',
  props: {
    user: Object,
    group: Object,
    level: Number,
    searchTerm: String,
    hideForParent: Boolean
  },
  data() {
    return {
      hideForSearch: false
    }
  },
  methods: {
    ...mapActions('user', ['resendConfirmUserEmail']),
    selectUser() {
      this.$store.commit('user/selectUser', {
        ...this.user,
        group: this.group
      });
      this.$bvModal.show(config.USER_MODAL_ID);
    }
  },
  computed: {
    ...mapGetters('user', ['isSuperUser', 'isStaffUser']),
    searchMatchesEmail() {
      return this.searchTerm != "" &&
        this.user.email.toLowerCase().includes(this.searchTerm.toLowerCase());
    },
    searchMatchesName() {
      return this.searchTerm != "" &&
        this.user.full_name.toLowerCase().includes(this.searchTerm.toLowerCase());
    },
    show() {
      return !this.hideForParent && !this.hideForSearch;
    },
    showResendEmail() {
      return !this.user.is_confirmed && (this.isSuperUser || this.isStaffUser);
    }
  },
  watch: {
    searchTerm(newTerm) {
      if (!newTerm) {
        this.hideForSearch = false;
      } else if (this.searchMatchesEmail || this.searchMatchesName) {
        this.$emit('searchFound', newTerm);
        this.hideForSearch = false;
      } else {
        this.hideForSearch = true;
      }
    }
  }
};
</script>

<style scoped>
.resend-email {
  color: white;
  cursor: pointer;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
